module.exports = flarum.core.compat['components/Placeholder'];